<template>
  <div id="changeMPwdDialog">
    <el-dialog
      :visible.sync="dialogVisible"
    >
      <p class="pwdTitle">修改资金密码</p>
      <div class="inputWrap">
        <QrDialog
          ref="qrDialog"
          title="重置资金密码二维码"
          :url="url"
          content="请使用手机扫码进行资金密码修改"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol*/
import QrDialog from './qrDialog.vue'
export default {
  components: {
    QrDialog
  },
  data() {
    return {
      tel: localStorage.getItem('myPhone'),
      dialogVisible: false,
      url: '',
      baseUrl: window.g.APP_PATH_mobile
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
      this.getSessionKey()
    },
    // 得到秘钥 --- 修改资金密码
    getSessionKey() {
      http
        .getRes(protocol.param_getSessionKey3)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#changeMPwdDialog {
  /deep/ .el-dialog {
    padding: 109px 0 199px;
    width: 1006px;
    // height: 708px;
    background-color: #F1F1F1 !important;
    border-radius: 8px;
    text-align: center;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
          color: #909399;
      }
    }
    .el-dialog__body {
      padding: 0;
    }
    .pwdTitle {
      font-size: 24px;
    }
    .inputWrap {
      img {
        width: 270px;
        height: 270px;
        margin:  49px auto 37px;
      }
    }
  }
}

</style>
